import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Apps.css';

const APPS = [
  {
    name: 'Academik',
    url: 'https://academik.codecolombia.com',
    description: 'Sistema de gestión escolar multi-tenant. Calificaciones, periodos académicos, certificados y boletines.',
    category: 'Educación',
    tags: ['React', 'Express', 'PostgreSQL'],
  },
  {
    name: 'AK1',
    url: 'https://ak1.codecolombia.com',
    description: 'Generador de certificados escolares conectado a SQL Server.',
    category: 'Educación',
    tags: ['React', 'Vite', 'SQL Server'],
  },
  {
    name: 'Analitik',
    url: 'https://analitik.codecolombia.com',
    description: 'Plataforma de análisis de grabaciones de llamadas con IBM Watson Speech-to-Text y NLU.',
    category: 'IA & Analytics',
    tags: ['React', 'Watson', 'Node.js'],
  },
  {
    name: 'Autolavado',
    url: 'https://autolavado.codecolombia.com',
    description: 'Sistema de gestión para lavaderos de autos. Control de pagos, lavadores y fidelización con QR.',
    category: 'Gestión',
    tags: ['Vanilla JS', 'Express', 'PostgreSQL'],
  },
  {
    name: 'Automate',
    url: 'https://automate.codecolombia.com',
    description: 'Plataforma de automatización de flujos de trabajo con n8n.',
    category: 'Automatización',
    tags: ['n8n', 'Docker'],
  },
  {
    name: 'Cintia',
    url: 'https://cintia.codecolombia.com',
    description: 'Chat RAG con IBM Granite LLM. Sube documentos y chatea contra tu base de conocimiento.',
    category: 'IA & Analytics',
    tags: ['React', 'watsonx.ai', 'Granite'],
  },
  {
    name: 'Evolution',
    url: 'https://evolution.codecolombia.com',
    description: 'Gateway API de WhatsApp con Evolution API. REST + WebSocket para gestión de conexiones.',
    category: 'Comunicaciones',
    tags: ['Docker', 'PostgreSQL', 'WebSocket'],
  },
  {
    name: 'Kontrol',
    url: 'https://kontrol.codecolombia.com',
    description: 'Dashboard ejecutivo de gestión con reportes de proyectos, finanzas y operaciones en PDF.',
    category: 'Gestión',
    tags: ['React', 'Vite', 'Tailwind'],
  },
  {
    name: 'Planning Project',
    url: 'https://planningproject.codecolombia.com',
    description: 'Herramienta de planificación de proyectos con timeline interactivo drag-and-drop y costos OTC/mensuales.',
    category: 'Gestión',
    tags: ['React', 'PostgreSQL', 'interact.js'],
  },
  {
    name: 'Recognizer',
    url: 'https://recognizer.codecolombia.com',
    description: 'Reconocimiento de imágenes con IBM Watson Visual Recognition.',
    category: 'IA & Analytics',
    tags: ['React', 'Watson', 'Node.js'],
  },
  {
    name: 'Recording',
    url: 'https://recording.codecolombia.com',
    description: 'Sistema de grabación de audio organizado por casos y categorías.',
    category: 'Productividad',
    tags: ['React', 'Express', 'Node.js'],
  },
  {
    name: 'Recplak',
    url: 'https://recplak.codecolombia.com',
    description: 'Sistema de vigilancia de placas vehiculares con alertas en tiempo real. OCR con Claude Vision API.',
    category: 'Seguridad',
    tags: ['React', 'Claude API', 'Socket.io'],
  },
  {
    name: 'SmartSales',
    url: 'https://smartsales.codecolombia.com',
    description: 'Plataforma B2B de ventas e inventario multi-rol con flujo de pre-ventas y despacho.',
    category: 'Ventas',
    tags: ['React', 'Vite', 'SQLite'],
  },
  {
    name: 'Trvely',
    url: 'https://trvely.codecolombia.com',
    description: 'Plataforma de reservas y cotizaciones para agencias de viajes colombianas.',
    category: 'Turismo',
    tags: ['React', 'PostgreSQL', 'QR'],
  },
  {
    name: 'Ubikar',
    url: 'https://ubikar.codecolombia.com',
    description: 'PWA de reconocimiento de placas vehiculares en tiempo real con alertas visuales y sonoras.',
    category: 'Seguridad',
    tags: ['React', 'Tesseract.js', 'PWA'],
  },
];

const CATEGORY_COLORS = {
  'Educación': { bg: 'rgba(6, 182, 212, 0.12)', border: 'rgba(6, 182, 212, 0.4)', text: '#22d3ee', glow: 'rgba(6, 182, 212, 0.15)' },
  'IA & Analytics': { bg: 'rgba(168, 85, 247, 0.12)', border: 'rgba(168, 85, 247, 0.4)', text: '#c084fc', glow: 'rgba(168, 85, 247, 0.15)' },
  'Gestión': { bg: 'rgba(59, 130, 246, 0.12)', border: 'rgba(59, 130, 246, 0.4)', text: '#60a5fa', glow: 'rgba(59, 130, 246, 0.15)' },
  'Automatización': { bg: 'rgba(245, 158, 11, 0.12)', border: 'rgba(245, 158, 11, 0.4)', text: '#fbbf24', glow: 'rgba(245, 158, 11, 0.15)' },
  'Comunicaciones': { bg: 'rgba(34, 197, 94, 0.12)', border: 'rgba(34, 197, 94, 0.4)', text: '#4ade80', glow: 'rgba(34, 197, 94, 0.15)' },
  'Productividad': { bg: 'rgba(244, 63, 94, 0.12)', border: 'rgba(244, 63, 94, 0.4)', text: '#fb7185', glow: 'rgba(244, 63, 94, 0.15)' },
  'Seguridad': { bg: 'rgba(239, 68, 68, 0.12)', border: 'rgba(239, 68, 68, 0.4)', text: '#f87171', glow: 'rgba(239, 68, 68, 0.15)' },
  'Ventas': { bg: 'rgba(16, 185, 129, 0.12)', border: 'rgba(16, 185, 129, 0.4)', text: '#34d399', glow: 'rgba(16, 185, 129, 0.15)' },
  'Turismo': { bg: 'rgba(14, 165, 233, 0.12)', border: 'rgba(14, 165, 233, 0.4)', text: '#38bdf8', glow: 'rgba(14, 165, 233, 0.15)' },
};

const CATEGORY_ICONS = {
  'Educación': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
    </svg>
  ),
  'IA & Analytics': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L12 22"/><path d="M8 6a4 4 0 0 1 .5-2"/><path d="M15.5 4A4 4 0 0 1 16 6c0 1.57-.9 2.93-2.2 3.6"/><path d="M6.5 8.5c-.83.52-1.5 1.5-1.5 2.5 0 1.5 1.12 2.75 2.6 2.96"/><path d="M17.5 8.5c.83.52 1.5 1.5 1.5 2.5 0 1.5-1.12 2.75-2.6 2.96"/>
    </svg>
  ),
  'Gestión': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/>
    </svg>
  ),
  'Automatización': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v4"/><path d="M12 18v4"/><path d="m4.93 4.93 2.83 2.83"/><path d="m16.24 16.24 2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="m4.93 19.07 2.83-2.83"/><path d="m16.24 7.76 2.83-2.83"/>
    </svg>
  ),
  'Comunicaciones': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  'Productividad': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  'Seguridad': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  'Ventas': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  'Turismo': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
};

function Apps() {
  const [filter, setFilter] = useState('Todas');
  const categories = ['Todas', ...new Set(APPS.map(a => a.category))];
  const filtered = filter === 'Todas' ? APPS : APPS.filter(a => a.category === filter);

  return (
    <div className="Apps">
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo">
            <span className="logo-icon">{'<>'}</span>
            <span className="logo-text">Code Colombia</span>
          </Link>
          <div className="nav-links">
            <Link to="/">Inicio</Link>
            <Link to="/apps" className="nav-active">Apps</Link>
          </div>
        </div>
      </nav>

      <section className="apps-hero">
        <div className="apps-hero-bg">
          <div className="apps-grid-pattern"></div>
          <div className="apps-orb apps-orb-1"></div>
          <div className="apps-orb apps-orb-2"></div>
        </div>
        <div className="apps-hero-content">
          <div className="apps-hero-badge">
            <span className="apps-badge-dot"></span>
            {APPS.length} sistemas activos
          </div>
          <h1 className="apps-hero-title">
            Nuestras <span className="gradient-text">Aplicaciones</span>
          </h1>
          <p className="apps-hero-subtitle">
            Ecosistema de soluciones desplegadas en producción. Cada aplicación resuelve un problema real para empresas colombianas.
          </p>
        </div>
      </section>

      <section className="apps-section">
        <div className="container">
          <div className="apps-filters">
            {categories.map(cat => (
              <button
                key={cat}
                className={`apps-filter-btn${filter === cat ? ' active' : ''}`}
                onClick={() => setFilter(cat)}
                style={filter === cat && cat !== 'Todas' ? {
                  borderColor: CATEGORY_COLORS[cat]?.border,
                  background: CATEGORY_COLORS[cat]?.bg,
                  color: CATEGORY_COLORS[cat]?.text,
                } : undefined}
              >
                {cat !== 'Todas' && CATEGORY_ICONS[cat]}
                {cat}
              </button>
            ))}
          </div>

          <div className="apps-grid">
            {filtered.map((app, i) => {
              const colors = CATEGORY_COLORS[app.category];
              return (
                <a
                  href={app.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-card"
                  key={app.name}
                  style={{
                    '--card-accent': colors.text,
                    '--card-glow': colors.glow,
                    '--card-border': colors.border,
                    animationDelay: `${i * 0.04}s`,
                  }}
                >
                  <div className="app-card-top">
                    <span
                      className="app-category"
                      style={{ background: colors.bg, borderColor: colors.border, color: colors.text }}
                    >
                      {CATEGORY_ICONS[app.category]}
                      {app.category}
                    </span>
                    <svg className="app-external-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                  </div>

                  <h3 className="app-name">{app.name}</h3>
                  <p className="app-description">{app.description}</p>

                  <div className="app-card-bottom">
                    <div className="app-tags">
                      {app.tags.map(tag => (
                        <span className="app-tag" key={tag}>{tag}</span>
                      ))}
                    </div>
                    <span className="app-url">{app.url.replace('https://', '')}</span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; Code Colombia</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Apps;
